import { render, staticRenderFns } from "./add_goods.vue?vue&type=template&id=76ff8734&scoped=true"
import script from "./add_goods.vue?vue&type=script&lang=js"
export * from "./add_goods.vue?vue&type=script&lang=js"
import style0 from "./add_goods.vue?vue&type=style&index=0&id=76ff8734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ff8734",
  null
  
)

export default component.exports